export type TimeParts = {
  hour: number;
  minute: number;
};

/** รวมวันที่ + เวลา (local) เป็น ISO string สำหรับ API */
export function combineDateTimeParts(
  date: Date | null | undefined,
  time: TimeParts | null | undefined,
): string | null {
  if (!date) return null;
  const d = new Date(date);
  d.setHours(time?.hour ?? 0, time?.minute ?? 0, 0, 0);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

/** แยก ISO string เป็นวันที่ + เวลา (local) */
export function splitDateTimeISO(iso: string | null | undefined): {
  date: Date | null;
  time: TimeParts | null;
} {
  if (!iso) return { date: null, time: null };
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { date: null, time: null };
  return {
    date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
    time: { hour: d.getHours(), minute: d.getMinutes() },
  };
}

export function formatTimeParts(time: TimeParts | null | undefined): string {
  if (!time) return "";
  return `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}`;
}

export function parseTimeString(value: string): TimeParts | null {
  const match = /^(\d{1,2}):(\d{2})$/.exec(value.trim());
  if (!match) return null;
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
  return { hour, minute };
}
